/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_Payment_TermsInputs */

const en_po_field_payment_terms = /** @type {(inputs: Po_Field_Payment_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment terms`)
};

/**
* | output |
* | --- |
* | "Payment terms" |
*
* @param {Po_Field_Payment_TermsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_payment_terms = /** @type {((inputs?: Po_Field_Payment_TermsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_Payment_TermsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_payment_terms(inputs)
});